import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import {
  mapStateToProps,
  surveysTableReducer,
  mapDispatchToProps,
} from "./SurveysTable.store";
import SurveysTable from "../../../library/BeyondXLH/SurveysTable/SurveysTable";
import history from "../../../../modules/history";
import { profiles } from "../../../../modules/constants";

export const SmartSurveysTable = (props) => {
  const {
    accountUsername,
    searchedParams,
    totalitems,
    fetchSurveys,
    surveys,
    canAnswerSurvey,
    canViewResults,
    participantId,
    role,
    resetState,
  } = props;

  const getData = useCallback(
    (params) => {
      fetchSurveys(params, participantId);
    },
    [fetchSurveys, participantId]
  );

  useEffect(() => {
    if (totalitems === null) {
      getData(searchedParams);
    }
  }, [getData, searchedParams, totalitems]);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  const handleAnswerSurvey = (survey) => {
    history.push(`/answer/${survey?.surveyDefinitionId}`);
  };

  const showSurveyResults = (survey) => {
    role === profiles.participant
      ? history.push(`/results/${survey?.surveyDefinitionId}`)
      : history.push(`/results/${survey?.surveyDefinitionId}/${participantId}`);
  };

  return (
    <SurveysTable
      accountUsername={accountUsername}
      totalitems={totalitems}
      getData={getData}
      searchedParams={searchedParams}
      surveys={surveys}
      canAnswerSurvey={canAnswerSurvey}
      canViewResults={canViewResults}
      role={role}
      showSurveyResults={showSurveyResults}
      handleAnswerSurvey={handleAnswerSurvey}
    />
  );
};

export default dynamic(
  "surveysTableReducer",
  subspaced({
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(surveysTableReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartSurveysTable));
